import {ApiAttributeParams, CrudSettings, QueryParams} from "../shared/crud/abstractions/base-crud";
import {CreateDefiniceVykazu, DefiniceVykazuDto, EditDefiniceVykazu} from "./models/DefiniceVykazuDto";
import {EnvironmentService} from "../core/environment/environment.service";
import {Injectable} from "@angular/core";
import {BasePagedCrudService} from "../shared/crud/base-crud.service";
import { HttpClient } from "@angular/common/http";
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ShowType, SnackMessage, SnackPropsUnion} from "../shared/dialog/snack-bar/snack-bar/snack-bar.component";
import {from} from "rxjs";

export class DefiniceVykazuCrud implements CrudSettings<string, DefiniceVykazuDto>
{
  baseUrl = '';
  postUrl = '';
  queryParam = undefined;
  createSuffix = undefined;
  editPostfix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'Vse';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: DefiniceVykazuDto) => entity.kod;

  mapper(id: string, from? : ApiAttributeParams): QueryParams {
    const dict = new Map<string, string>();
    if(from)
    {
      dict.set(from,id)
      return { params: dict };
    }
    dict.set('id', id);
    return { params: dict };
  }
  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/DefiniceVykazu/Vykaz';
  }
}

@Injectable
({
  providedIn: null
})
export class DefiniceVykazuDataService
  extends BasePagedCrudService<string, DefiniceVykazuDto, CreateDefiniceVykazu,EditDefiniceVykazu>
{
  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new DefiniceVykazuCrud(environmentService), dialogService);
  }
}

